import React from "react";
import Slideshow from "../../components/page-components/Slideshow";
import { Row, Col } from "react-bootstrap";

// All images are stored in here and passed to slideshow object to be displayed
const imgs = [
  {
    id: 1,
    src: "/img/scholarship/2023_caregiver_winner.png",
  },
  {
    id: 2,
    src: "/img/scholarship/2024_caregiver_winner.png",
  },
];

const ScholarshipScreen = () => {
  return (
    <>
      <h1 className="title">The LOYM Caregiver Scholarship</h1>;
      <Row className="justify-content-md-center">
        <Col sm={6}>
          <div className="text-box">
            <p>
              LOYM'S Caregiver Scholarship is awarded to a deserving Mom that
              provides care to a family remember due to illness or to a child
              with special needs. Our Founder. Jackie Hardy started the
              scholarship to honor her Mother & Father. Her Mother was diagnosed
              with breast cancer in 2023 and she saw firsthand the sacrifice
              caregivers provide through her Father who has be faithful care
              giver to her Mom.
            </p>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      <h2 className="text-center">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSctUYCPZcgVbMtwa7sU2zIyZJupWIcQgys317K_Oqg44VhIEA/viewform"
          target="_blank"
          className="button lg"
        >
          Click here to apply
        </a>
      </h2>
      <br />
      <br />
      <hr />
      <br />
      <h1 className="title">Scholarship Recipients:</h1>
      <Row className="justify-content-md-center">
        <Col sm={12} lg={6}>
          <Slideshow images={imgs} />
        </Col>
      </Row>
    </>
  );
};

export default ScholarshipScreen;
